import CloseIcon from '@mui/icons-material/Close';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';

const SUMMARY_CARD_SX = {
  bgcolor: '#eef1f8',
  borderLeft: '4px solid #031c57',
  borderRadius: 1,
  p: 2,
  mb: 2,
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: 1.5,
};

const LOCK_INFO_TEXT = `Starting a physical count will temporarily lock this item.
While locked:
• Product fulfillment (WIP Init) is blocked
• Manual Inventory Adjustment is blocked
• Reversal Review allocation is blocked
The lock is released when you submit or cancel the count.`;

const SummaryCell = ({ label, value }) => (
  <Box>
    <Typography variant='caption' color='text.secondary'>
      {label}
    </Typography>
    <Typography variant='body2' fontWeight={600}>
      {value || '—'}
    </Typography>
  </Box>
);

SummaryCell.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
};
SummaryCell.defaultProps = { value: '' };

const StartCountConfirmDialog = ({ open, onClose, onConfirm, itemData, loading }) => (
  <Dialog open={open} onClose={loading ? undefined : onClose} maxWidth='sm' fullWidth>
    <DialogTitle sx={{ pr: 6 }}>
      <Typography variant='h6' component='span' fontWeight={700}>
        Start Physical Count
      </Typography>
      <IconButton
        onClick={onClose}
        disabled={loading}
        sx={{ position: 'absolute', right: 8, top: 8 }}
        aria-label='close'
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent dividers>
      <Box sx={SUMMARY_CARD_SX}>
        <SummaryCell label='Drug Name' value={itemData?.drugName} />
        <SummaryCell label='Strength' value={itemData?.strength} />
        <SummaryCell label='NDC' value={itemData?.ndc} />
        <SummaryCell label='Manufacturer' value={itemData?.manufacturer} />
        <SummaryCell label='Facility' value={itemData?.facilityName} />
      </Box>
      <Alert severity='info' sx={{ whiteSpace: 'pre-line' }}>
        {LOCK_INFO_TEXT}
      </Alert>
    </DialogContent>
    <DialogActions>
      <Button variant='text' onClick={onClose} disabled={loading}>
        Cancel
      </Button>
      <Button
        variant='contained'
        color='primary'
        onClick={onConfirm}
        disabled={loading}
        startIcon={loading ? <CircularProgress size={16} color='inherit' /> : null}
      >
        Start Count
      </Button>
    </DialogActions>
  </Dialog>
);

StartCountConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  itemData: PropTypes.shape({
    drugName: PropTypes.string,
    strength: PropTypes.string,
    ndc: PropTypes.string,
    manufacturer: PropTypes.string,
    facilityName: PropTypes.string,
  }),
  loading: PropTypes.bool,
};
StartCountConfirmDialog.defaultProps = {
  itemData: null,
  loading: false,
};

export default StartCountConfirmDialog;
